<template>
  <b-modal
    v-model="showModal"
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    size="lg"
  >
    <b-overlay :show="isLoading">
      <div class="setup">
        <div class="setup__header">
          <div
            v-if="Object.keys(answers).length >= 5"
            class="d-flex align-items-center justify-content-end"
          >
            <a href="#" @click.prevent="skipSetup">
              <b-icon-skip-end />
              продовжити пізніше</a
            >
          </div>
          <h3>Завершення реєстрації</h3>
          <p>
            Дайте, будь ласка, відповідь на кілька запитань, аби завершити
            реєстрацію
          </p>
          <div class="info">
            Запитання {{ current_index + 1 }} із {{ questions.length }}
          </div>
        </div>
        <div class="setup__question">
          <h2>{{ currentQuestion.text }}</h2>
          <template v-if="currentQuestion.type == 'text'">
            <b-form-input type="text" v-model="answers[currentQuestion.key]" />
          </template>
          <template v-if="currentQuestion.type == 'select'">
            <v-select
              v-model="answers[currentQuestion.key]"
              :options="currentQuestion.options"
              :reduce="(option) => option.value"
            />
          </template>
          <template v-if="currentQuestion.type == 'textarea'">
            <b-form-textarea rows="4" v-model="answers[currentQuestion.key]" />
          </template>
        </div>
        <div
          class="setup__footer d-flex align-items-center justify-content-between pt-4"
        >
          <b-button
            @click="prevQuestion"
            v-if="current_index != 0"
            variant="secondary-outline"
          >
            Попереднє запитання
          </b-button>

          <b-button
            style="margin-left: auto"
            variant="primary"
            size="lg"
            v-if="current_index + 1 < questions.length"
            :disabled="noCurrentAnswer"
            @click="nextQuestion"
          >
            Продовжити
          </b-button>
          <b-button
            style="margin-left: auto"
            variant="primary"
            size="lg"
            v-else
            :disabled="noCurrentAnswer"
            @click="finishSetup"
          >
            Завершити
          </b-button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import regions from "@/assets/data/regions.json";
export default {
  props: ["show"],
  data() {
    return {
      isLoading: false,
      showModal: false,
      current_index: 0,
      answers: {},
      regions: regions,
      cities: [],
      questions: [
        {
          text: "Регіон проживання",
          type: "select",
          key: "region",
          options: [],
        },
        {
          text: "Нас. пункт проживання",
          type: "select",
          key: "city",
          options: [],
        },
        {
          text: "Ваш рівень освіти та спеціалізація",
          type: "text",
          key: "education",
          min_length: 10,
        },
        {
          text: "Ваша посада",
          type: "text",
          key: "position",
          min_length: 10,
        },
        {
          text: "Які спеціалізовані знання бажаєте отримати?",
          type: "text",
          key: "skills_to_get",
          min_length: 10,
        },
        {
          text: "Що вважаєте особисто для себе «зоною зросту»?",
          type: "text",
          key: "growth_area",
          min_length: 10,
        },
        {
          text: "Які Ваші професійні якості можуть бути корисними для потенціального роботодавця у державній сфері?",
          type: "textarea",
          key: "professional_skills",
          min_length: 10,
        },
        {
          text: "Ваш рівень знання державної мови",
          type: "select",
          key: "language_level",
          options: [
            {
              label: "нижче середнього",
              value: "нижче середнього",
            },
            {
              label: "середній",
              value: "середній",
            },
            {
              label: "вище за середній",
              value: "вище за середній",
            },
            {
              label: "рідна мова",
              value: "рідна мова",
            },
          ],
        },
        {
          text: "Ваш рівень знання англійської мови",
          type: "select",
          key: "english_level",
          options: [
            {
              label: "pre-intermediate",
              value: "pre-intermediate",
            },
            {
              label: "intermediate",
              value: "intermediate",
            },
            {
              label: "upper-intermediate",
              value: "upper-intermediate",
            },
            {
              label: "advanced",
              value: "advanced",
            },
            {
              label: "proficiency",
              value: "proficiency",
            },
          ],
        },
      ],
    };
  },
  computed: {
    noCurrentAnswer() {
      let disable = true;
      let current_key = this.currentQuestion.key;
      if (this.answers[current_key]) {
        disable = false;
      }

      return disable;
    },
    currentQuestion() {
      return this.questions[this.current_index];
    },
    formattedRegions() {
      return this.regions.map((el) => {
        return {
          value: el.level_1,
          label: el.name_ua,
        };
      });
    },
  },
  watch: {
    answers: {
      deep: true,
      handler(newVal) {
        let length = 0;
        for (var key in newVal) {
          console.log(key);
          length++;
        }
        if (length == 1) {
          this.fetchCities();
        }
      },
    },
    show: {
      handler() {
        this.showModal = this.show;
      },
    },
  },
  methods: {
    skipSetup() {
      this.enitClose();
    },
    finishSetup() {
      this.updateUser(true);
    },
    async updateUser(finish) {
      this.isLoading = true;
      let data = {
        info: this.answers,
      };
      if (finish) {
        data["setup_completed"] = true;
      }
      await this.$db.update("users", this.$store.state.user.uid, data);
      this.isLoading = false;

      if (finish) {
        this.$toast.success("Реєстрацію завершено");
        this.enitClose();
      }
    },
    prevQuestion() {
      if (this.current_index > 0) {
        this.current_index--;
        if (this.current_index == 1 && this.cities.length == 0) {
          this.current_index--;
        }
      }
    },
    nextQuestion() {
      if (this.current_index + 1 < this.questions.length) {
        this.current_index++;
        if (this.current_index == 1 && this.cities.length == 0) {
          this.current_index++;
        }
        this.updateUser();
      }
    },
    async fetchCities() {
      let result = await this.$api.get(
        "/koatuu/cities/?region=" + this.answers.region
      );
      console.log(result);
      this.cities = result.data.map((el) => {
        return {
          label: el.name_ua,
          value: el.level_2,
        };
      });

      this.questions[1].options = this.cities;
    },
    async fetchRegions() {
      let result = await this.$api.get("/koatuu/regions/");
      regions = result;
    },
    resumeSetup() {
      if (this.$store.state.userData.info) {
        this.answers = this.$store.state.userData.info;
        if (this.answers.region) {
          this.fetchCities();
        }
        this.current_index = Object.keys(this.answers).length - 1;
      }
    },
    enitClose() {
      this.$emit("close");
    },
  },
  mounted() {
    this.showModal = this.show;
    this.questions[0].options = this.formattedRegions;
    this.resumeSetup();
  },
};
</script>

<style lang="scss" scoped>
.setup {
  &__header {
    h3 {
      font-size: 32px;
      margin-bottom: 0 !important;
    }
    color: var(--primary-color);
    .info {
      margin-right: auto;
      color: #666;
    }
    a {
      text-decoration: none;
      font-size: 14px;
    }
  }
  &__footer {
  }
}
</style>
